import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import PackagingFlowDiagram from '../components/PackagingFlowDiagram';
import ProblemSection from '../components/ProblemSection';
import SolutionSection from '../components/SolutionSection';
import HowItWorks from '../components/HowItWorks';
import BenefitsSection from '../components/BenefitsSection';
import IndustriesGrid from '../components/IndustriesGrid';
import UseCasesSection from '../components/UseCasesSection';
import ProductSuite from '../components/ProductSuite';
import PlatformSection from '../components/PlatformSection';
import DeploymentSection from '../components/DeploymentSection';
import SocialProofSection from '../components/SocialProofSection';
import QualificationForm from '../components/QualificationForm';
import FAQSection from '../components/FAQSection';
import Footer from '../components/Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Add padding-top to account for fixed header */}
      <main className="pt-20">
        <Hero />
        <PackagingFlowDiagram />
        <ProblemSection />
        <SolutionSection />
        <div id="how-it-works">
          <HowItWorks />
        </div>
        <BenefitsSection />
        <div id="industries">
          <IndustriesGrid />
        </div>
        <UseCasesSection />
        <div id="products">
          <ProductSuite />
        </div>
        <PlatformSection />
        <DeploymentSection />
        <SocialProofSection />
        <QualificationForm />
        <div id="faq">
          <FAQSection />
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default LandingPage;
